import { Button, Card, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import { ESIA_TYPE, getLoginUrl, LOGIN_TYPE } from '@sravni/utils/lib/auth';
import { useCallback } from 'react';

import EsiaPng from '../assets/esia.png';

import styles from './EsiaConsentBanner.module.scss';
import { EsiaConsentBannerTexts } from './EsiaConsentBanner.texts';

export const EsiaConsentBanner = () => {
  const isMobile = useIsMobile();

  const goToEsia = useCallback(() => {
    window.location.href = getLoginUrl({
      returnUrl: window.location.href,
      loginType: LOGIN_TYPE.ESIA,
      esiaType: ESIA_TYPE.STRICT,
    });
  }, []);

  return (
    <Card
      size={16}
      className={styles.card}
      color="blue"
    >
      <Space
        justify="space-between"
        direction={isMobile ? 'column' : undefined}
        size={isMobile ? 12 : undefined}
      >
        <Space size={24}>
          <img
            className={styles.img}
            height={84}
            src={EsiaPng}
            alt={EsiaConsentBannerTexts.imageAlt}
          />

          <Space
            direction="column"
            justify="center"
            size={4}
            className={styles.text}
          >
            <Typography.Text
              size={isMobile ? 14 : 16}
              strong
            >
              {EsiaConsentBannerTexts.title}
            </Typography.Text>

            <Typography.Text size={14}>
              {isMobile ? (
                <>
                  {EsiaConsentBannerTexts.subtitleBeforeBreak}
                  <br />
                  {EsiaConsentBannerTexts.subtitleAfterBreak}
                </>
              ) : (
                EsiaConsentBannerTexts.subtitle
              )}
            </Typography.Text>
          </Space>
        </Space>

        <Space
          className={styles.button}
          justify={isMobile ? undefined : 'end'}
        >
          <Button
            onClick={goToEsia}
            size={52}
            color="blue"
            variant="primary"
          >
            {EsiaConsentBannerTexts.button}
          </Button>
        </Space>
      </Space>
    </Card>
  );
};
